import http from "@/shared/services/http";
import {ReportDeliveryParams} from "@/modules/reportdelivery/params";

export const singleReportDelivery = (id: string) => http.get(`v1/report-deliveries/${id}`);
export const updateReportDelivery = (id: string, data: any) => http.put(`v1/report-deliveries/${id}`, data);
export const listReportDelivery = (params: ReportDeliveryParams) => http.get(`v1/report-deliveries`, {params});
export const createReportDelivery = (data: any) => http.post(`v1/report-deliveries/success`, data);
export const createReportDeliveryExcel = (data: any) => http.post(`v1/report-deliveries/excel`, data);
export const lastByBillLadingRowGuid = (id: string) => http.get(`v1/report-deliveries/by-lading-row-guid/${id}`);
